module.exports = __webpack_public_path__ + "img/problems-6.e3d6ffd5.png";